import { AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

interface PortalErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
  /** Offers "Sign in again" (used when a request is rejected as unauthenticated) */
  onSignIn?: () => void;
  fullScreen?: boolean;
}

export function PortalErrorState({
  title = 'Something went wrong',
  message = 'We could not load this page. Please try again.',
  onRetry,
  onSignIn,
  fullScreen = false,
}: PortalErrorStateProps) {
  const card = (
    <Card className="w-full max-w-md text-center">
      <CardContent className="pt-8 pb-8">
        <AlertCircle className="mx-auto mb-4 h-12 w-12 text-destructive" />
        <h2 className="mb-2 text-lg font-semibold">{title}</h2>
        <p className="text-sm text-muted-foreground">{message}</p>
        {(onRetry || onSignIn) && (
          <div className="mt-6 flex flex-col justify-center gap-2 sm:flex-row">
            {onRetry && <Button variant="outline" onClick={onRetry}>Try again</Button>}
            {onSignIn && <Button onClick={onSignIn}>Sign in again</Button>}
          </div>
        )}
      </CardContent>
    </Card>
  );
  if (!fullScreen) return <div className="flex justify-center">{card}</div>;
  return <div className="min-h-screen bg-muted flex items-center justify-center p-4">{card}</div>;
}
